import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {noTimeZoneShortISODate} from '../../../common/constants/datesFormat';

class FileDownload extends Component {
  constructor(props) {
    super(props);
    this.state = {'currentDate': moment().format(noTimeZoneShortISODate)};
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
  }
  
  handleDownloadClick() {
    const {dealer, agency, orderCode} = this.props;

    this.props.downloadPossFile({
      dealer,
      agency,
      orderCode,
      'initialDate': this.state.currentDate,
      'finalDate': this.state.currentDate,
    });
  }

  render() {
    const {orderCode, downloading} = this.props;

    if (!orderCode) {
      return null;
    }

    return (
      <Button primary
        content='DESCARGAR'
        disabled={downloading}
        onClick={this.handleDownloadClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'dealer': state.dealerStockOrders.orderDealer,
    'agency': state.dealerStockOrders.orderAgency,
    'orderCode': state.dealerStockOrders.createdOrder,
    'downloading': state.possDownload.loading,
  };
};

const {
  downloadPossFile,
} = Actions;

export default connect(mapStateToProps, {downloadPossFile})(FileDownload);
